import { render } from "./PartnerAqua.vue?vue&type=template&id=36d4ad0e"
import script from "./PartnerAqua.vue?vue&type=script&lang=js"
export * from "./PartnerAqua.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__